import { createAuthGuard } from './components/AuthGuard';
import { createGoogleAuthProvider } from './components/GoogleAuthProvider';
import { createGoogleLoginButton } from './components/GoogleLoginButton';
import { createAuthStore } from './store';

import type { GoogleAuthKitConfig, UseAuthStore } from './types';

export type GoogleAuthKit = {
  useAuthStore: UseAuthStore;
  GoogleAuthProvider: React.FC<{ children: React.ReactNode }>;
  GoogleLoginButton: React.FC;
  AuthGuard: React.FC<{
    children: React.ReactNode;
    fallback: React.ReactNode;
    loading?: React.ReactNode;
  }>;
};

export function createGoogleAuthKit(config: GoogleAuthKitConfig): GoogleAuthKit {
  const useAuthStore = createAuthStore(config);
  const GoogleAuthProvider = createGoogleAuthProvider(useAuthStore, config);
  const GoogleLoginButton = createGoogleLoginButton(useAuthStore, config);
  const AuthGuard = createAuthGuard(useAuthStore);

  return { useAuthStore, GoogleAuthProvider, GoogleLoginButton, AuthGuard };
}
